module.exports = function (controller, urlRoot) {
    // Imports
    const $ = window.$;

    var API = {
        root: urlRoot
    };

    API.AddHook = function (name, httpMethod, truthyVar, loadingMessage, isJSON, errorMsgVar) {
        var transformCallback = function (data) { return data; };
        var errorCallback = function () { };
        var successCallback = function () { };

        var HOOK = {
            TransformIncoming: function (callback) {
                transformCallback = callback;
                return this;
            },
            OnError: function (callback) {
                errorCallback = callback;
                return this;
            },
            OnSuccess: function (callback) {
                successCallback = callback;
                return this;
            }
        };

        var isSuccess;
        if (!truthyVar) {
            isSuccess = function() {return true;};
        } else {
            isSuccess = function (data) {
                return data[truthyVar];
            }
        }

        var getErrorMsg;
        if (!errorMsgVar) {
            getErrorMsg = function (data) {
                var msg = 'Failure';
                if (data && data.ErrorMessage) {
                    msg = data.ErrorMessage;
                } else if (data && data.Message) {
                    msg = data.Message;
                }
                return msg;
            };
        } else {
            isSuccess = function (data) {
                return data[errorMsgVar];
            }
        }

        loadingMessage = loadingMessage ? loadingMessage : 'Gathering requested data';

        controller[name] = function (args) {
            var dataToSend = transformCallback(args);

            var ajax = {};

            if (isJSON) {
                ajax = $.ajax({
                    method: httpMethod,
                    url: '/' + API.root + '/' + name,
                    data: JSON.stringify(dataToSend),
                    contentType: 'application/json',
                    timeout: 0,
                    error: function (req, txt, err) {
                    }
                });
            } else {
                ajax = $.ajax({
                    method: httpMethod,
                    url: '/' + API.root + '/' + name,
                    data: dataToSend,
                    timeout: 0,
                    error: function (req, txt, err) {
                    }
                });
            }

            ajax.done(function (data, msg) {
                if (data && isSuccess(data)) {
                    successCallback(data, args);
                }
                else {
                    errorCallback();
                }
            });
        }
        return HOOK;
    }

    API.AddJSONHook = function (name, httpMethod, truthyVar, loadingMessage, errorMsgVar) {
        return API.AddHook(name, httpMethod, truthyVar, loadingMessage, true);
    }

    return API;
}


// WEBPACK FOOTER //
// ./Scripts/lib/api-base.js